import VideoListingContentComponent from "./VideoListingContentComponent";

const VideoListingMy =()=>{


    return (<>
        <VideoListingContentComponent
                tabKey={"my-videos"}
                showMostPopular={false}
                showMostLiked={false}
                showMyVideos={true}
                showAllVideos={false}
            /></>)
}
export default VideoListingMy;